import { combineReducers } from "redux";
import { DashboardReducer } from "./reducers/Dashboard/Dashboard";
import { SrfReducer } from "./reducers/Srf/Srf";
import { SrtReducer } from "./reducers/Srt/Srt";
import { ProfileReducer } from "./reducers/Profile/Profile";
import { srReducer } from "./reducers/Sr/Sr";
import { ArchivedBrandsReducer } from "./reducers/ArchivedBrands/ArchivedBrands";

const rootReducer = combineReducers ({
     Dashboard : DashboardReducer,
     Srt: SrtReducer,
     Srf: SrfReducer,
     Profile: ProfileReducer,
    Sr: srReducer,
    ArchivedBrands: ArchivedBrandsReducer
  })

export default rootReducer;